import { Button } from "@/components/ui/button";
import { Play, Facebook, Instagram, Twitter, Youtube } from "lucide-react";
import { Linden_Hill } from "next/font/google";
import Image from "next/image";
import Link from "next/link";

export function AboutSection() {
  return (
    <section className="py-20 bg-primary">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="relative">
            <div className="aspect-[4/3] rounded-lg overflow-hidden">
              <Image
                src="/images/restaurant-interior.jpeg"
                alt="Restaurant interior"
                className="w-full h-full object-cover"
                width={500}
                height={500}
              />
            </div>
          </div>

          {/* Right - Content */}
          <div>
            {/* Section Label */}
            <div className="flex items-center mb-6">
              <div className="h-0.5 w-12 bg-secondary mr-4"></div>
              <span className="text-secondary font-medium tracking-wider text-sm uppercase">
                Despre noi
              </span>
            </div>

            {/* Heading */}
            <h2 className="text-2xl lg:text-3xl font-bold text-slate-900 mb-6 leading-tight">
              Vă invităm să vizitați restaurantul nostru
            </h2>

            {/* Description */}
            <p className="text-gray-600 text-lg mb-8 leading-relaxed">
              Pășind în acest restaurant chinezesc autentic, vei simți imediat
              atmosfera orientală.
            </p>

            <p className="text-gray-600 text-lg mb-8 leading-relaxed">
              Meniul aduce în prim-plan rețete transmise din generație în
              generație, preparate cu ingrediente proaspete și tehnici de gătit
              păstrate cu grijă. Printre specialități se regăsesc rața Peking ,
              supă picant-acrișoară și preparate wok aromate, gătite rapid la
              foc iute pentru a păstra textura și savoarea naturală.
            </p>

            <p className="text-gray-600 text-lg mb-8 leading-relaxed">
              Restaurantul oferă o experiență completă: Rata peking, vita pe
              plita încinsă, creveti, pui Gong Bao,pachetelele de primăvară,
              noodles deserturi precum înghețată prăjită, banane prajite cu nuca
              de cocos și un serviciu atent, care păstrează ospitalitatea
              chinezească clasică.
            </p>

            <p className="text-gray-600 text-lg mb-8 leading-relaxed">
              Este locul ideal pentru cei care vor să descopere adevărata
              bucătărie chineză autentică, departe de adaptările occidentale,
              într-o atmosferă ce îmbină tradiția cu rafinamentul modern.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
